// const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development';
const isDevelopment = true;

const config = {
    development: {
        host: 'https://dev.dynamichealth.today',
        login: 'https://dev.dynamichealth.today'
    },
    local: {
        host: 'http://localhost/DynamicHealthApp',
        login: 'http://localhost/DynamicHealthApp'
    },
    uat: {
        host: 'https://uatapp.dynamichealth.today',
        login: 'https://uatapp.dynamichealth.today'
    },
    production: {
        host: 'https://app.dynamichealth.today',
        login: 'https://dynamichealth.today'
    }
};
//export default config.local;
export default config.uat;
//export default isDevelopment ? config.development : config.production;